import { j as l } from "./jsx-runtime-e6RZPHeG.js";
import { memo as s } from "react";
const r = ({
  title: c,
  titleId: e,
  ...o
}) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": e,
    ...o,
    children: [
      c ? /* @__PURE__ */ l.jsx("title", { id: e, children: c }) : null,
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M506.887 643.902c-75.363 0-136.332-62.282-136.332-139.281S431.524 365.34 506.887 365.34c75.388 0 136.332 62.282 136.332 139.281s-60.945 139.281-136.332 139.281m299.916-92.06c-6.54-5.252-9.835-13.428-9.067-21.801.793-8.398 1.288-16.846 1.288-25.418s-.495-17.045-1.288-25.394c-.768-8.374 2.527-16.574 9.092-21.826l71.87-57.451c7.383-5.971 9.538-16.698 4.658-25.468l-77.89-137.868c-4.905-8.572-15.013-12.164-23.758-8.572l-84.133 34.684c-7.977 3.295-16.97 1.982-24.031-3.047-13.378-9.538-27.524-18.011-42.413-25.245-7.556-3.667-12.957-10.603-14.097-18.927l-12.759-92.135c-1.759-9.34-9.736-16.723-19.473-16.723h-155.83c-9.711 0-17.714 7.383-19.274 16.723l-12.734 92.11c-1.164 8.324-6.59 15.286-14.146 18.952a290.264 290.264 0 0 0-42.389 25.146c-7.036 5.079-16.078 6.417-24.081 3.122l-84.059-34.659c-8.77-3.394-18.903 0-23.783 8.572l-77.89 137.868c-4.881 8.572-2.725 19.299 4.682 25.468l71.672 57.451c6.54 5.252 9.835 13.428 9.067 21.801s-1.288 16.846-1.288 25.418.52 17.02 1.288 25.418c.768 8.374-2.527 16.549-9.067 21.801l-71.672 57.451c-7.407 5.971-9.563 16.698-4.682 25.468l77.89 137.868c4.881 8.572 15.013 12.164 23.783 8.572l84.108-34.659c7.977-3.32 16.995-2.007 24.031 3.022 13.353 9.538 27.524 18.011 42.413 25.245 7.556 3.691 12.957 10.603 14.121 18.927l12.734 92.135c1.561 9.365 9.563 16.698 19.274 16.698H584.8c9.711 0 17.714-7.333 19.274-16.698l12.734-92.11c1.164-8.324 6.59-15.286 14.146-18.952a288.056 288.056 0 0 0 42.389-25.146c7.036-5.103 16.078-6.417 24.105-3.097l84.059 34.634c8.745 3.394 18.878 0 23.758-8.572l77.89-137.868c4.881-8.572 2.725-19.299-4.682-25.468l-71.672-57.451z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), n = s(r);
export {
  n as default
};
